import React from "react";
import { useTranslation } from "react-i18next";
import { LinkEntityApi, PurchaseApi } from "../../../../../../../../../../../services/Api/Organization/types";
import PurchaseItemsCardTableBody from "./PurchaseItemsCardTableBody";

interface Props {
	setProductToLink: (product: LinkEntityApi | undefined) => void;
	setProductIndexToLink: (index: number) => void;
	fileImportPreviewMode?: boolean;
	purchase: PurchaseApi;
}

const PurchaseItemsCardTable = ({
	fileImportPreviewMode,
	setProductToLink,
	setProductIndexToLink,
	purchase,
}: Props) => {
	const { t } = useTranslation();
	const isActionColumnShown = purchase.items.some((item) => item?.product_id || item?.linked_product?.id);

	return (
		<div className="table-responsive">
			<table className="table table-preview">
				<thead>
					<tr>
						<th>{t("lib:common.word.name")}</th>
						<th>{t("common.word.volume")}</th>
						<th>{t("common.word.quantity")}</th>
						<th>{t("modules.purchase.field.quantity_received.title")}</th>
						<th>{t("common.word.total_volume")}</th>
						<th>{t("modules.purchase.field.price.title")}</th>
						<th>
							{t("common.word.vat_rate")} <br />
							{t("common.word.vat")}
						</th>
						<th>{t("common.word.value")}</th>
						{isActionColumnShown && <th className="action" />}
					</tr>
				</thead>
				<PurchaseItemsCardTableBody
					setProductIndexToLink={setProductIndexToLink}
					setProductToLink={setProductToLink}
					fileImportPreviewMode={fileImportPreviewMode}
					purchase={purchase}
				/>
			</table>
		</div>
	);
};

export default PurchaseItemsCardTable;
